
const tableHeadings = [
  {
    id: 'name',
    header: 'NAME',
  },
  {
    id: 'actions',
    header: 'EDIT TAG'
  },
  {
    id: 'totalSystems',
    header: 'TOTAL SYSTEMS'
  },
  {
    id: 'status',
    header: ''
  }
]

export {
  tableHeadings
}